import strings from 'strings';

const COPIES = strings.inventoryProfiles.sections.tabs.sales;
export const SALES_COLUMNS = [
  {
    name: 'id',
    options: {
      filter: false,
      display: 'excluded'
    }
  },
  {
    name: 'status',
    label: COPIES.talbeColumns.status,
    options: {
      sort: false,
      display: true
    }
  },
  {
    name: 'candidateName',
    label: COPIES.talbeColumns.candidate,
    options: {
      sort: false,
      display: true
    }
  },
  {
    name: 'transactionName',
    label: COPIES.talbeColumns.documentNumber,
    options: {
      sort: false,
      display: true
    }
  },
  {
    name: 'memo',
    label: COPIES.talbeColumns.memo,
    options: {
      sort: false,
      display: true
    }
  },
  {
    name: 'total',
    label: COPIES.talbeColumns.amount,
    options: {
      sort: false,
      display: true,
      renderer: 'currency'
    }
  },
  {
    name: 'createdAt',
    label: COPIES.talbeColumns.createdOn,
    options: {
      sort: false,
      display: true,
      renderer: 'date'
    }
  },
  {
    name: 'trandate',
    label: COPIES.talbeColumns.transactionDate,
    options: {
      sort: false,
      display: true
    }
  },
  {
    name: 'dueDate',
    label: COPIES.talbeColumns.dueDate,
    options: {
      sort: false,
      display: true
    }
  },
  {
    name: 'onCollections',
    label: COPIES.talbeColumns.onCollections,
    options: {
      sort: false,
      display: true
    }
  },
  {
    name: 'notes',
    label: COPIES.talbeColumns.notes,
    options: {
      sort: false,
      display: true
    }
  },
  {
    name: 'openBillingText',
    label: COPIES.talbeColumns.openBillingText,
    options: {
      sort: false,
      display: false
    }
  }
];
